<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (max-width: @max-screen){
  .el-tab-pane{font-size: 14px;width: 10px;position: relative;}
  .sp1{position: absolute;top: 18%;font-size: 20px;font-weight: bold;}
  .sp2{position: absolute;top: 75%;font-size: 20px;font-weight: bold;}
  .morning{margin-left: 40px;border-left: 2px dashed #9ecaed;position: relative;display: flex;flex-direction: column;justify-content: center;}
  .ftime{font-size: 15px;font-weight: bold;background: #F5FAFE;margin-top: -30px;margin-left: -6px;}
  .etime{font-size: 15px;font-weight: bold;background: #F5FAFE;margin-left: -25px;}
  li {display: flex;width: 478px;font-size: 18px;border-width:1px;align-items: center;}
  .meetingtime{margin-top: 0px;background: #B7DBFA;width: 34%;font-weight: bold;}
  .address{margin-top: 0px;background: #B7DBFA;width: 30%;font-weight: bold;margin-left: -56px;}
  .meeting{margin-top: 0px;background: #B7DBFA;width: 40%;font-weight: bold;margin-left: -40px;}
  ul li{background-color:#e4f4fa;margin-left: 10px;width: 285px;font-size: 14px;}
  .time{width: 250px;margin-left: 10px;font-size: 14px;text-align: center;}
  .afternoon{margin-left: 40px;border-left: 2px dashed #9ecaed;position: relative;display: flex;flex-direction: column;justify-content: center;
  .ftime{font-size: 15px;font-weight: bold;background: #F5FAFE;margin-top: -31px;margin-left: -25px;}
  .etime{font-size: 15px;font-weight: bold;margin-left: -25px;}}
  .night{margin-left: 40px;border-left: 2px dashed #9ecaed;position: relative;height:105px;
  .ftime{position: absolute;top: 10px;left:20px;font-size: 15px;font-weight: bold;background: #F5FAFE;}
  .etime{position: absolute;top: 88px;left:40px;font-size: 15px;font-weight: bold;}}
  ul li:nth-child(2n+1){background-color:#e9f9f9;}
  .night::before {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; position: absolute;top: -27px;left: -10px;color: #1265F6;}
  .night::after {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; position: absolute;top: 60px;left: -10px;color: #1265F6;}
  .afternoon::before {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top;color: #1265F6;margin-left: -78px;}
  .afternoon::after{content: "●";font-size: 30px;margin-right: 4px;vertical-align: top;color: #1265F6;margin-left: -78px;margin-top: -25px;}
  .morning::before {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; color: #1265F6;margin-left: -78px;}
  .morning::after {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; color: #1265F6;margin-left: -78px;margin-top: -29px;}
  .noon{margin-left: 40px;border-left: 2px dashed #9ecaed;position: relative;
    .ftime{position: absolute;top: -16px;margin-left: -25px;font-size: 15px;font-weight: bold;background: #F5FAFE;}
    .etime{position: absolute;top: 64px;margin-left: -25px;font-size: 15px;font-weight: bold;background: #F5FAFE;}
  }
  .noon::before {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; position: absolute;top: -27px;left: -10px;color: #1265F6;}
  .noon::after {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; position: absolute;top: 52px;left: -10px;color: #1265F6;}
  .arrangement{width: 280px;cursor: pointer;text-align: center;margin-left: 25px;}
  /deep/.el-tabs__item {font-size: 16px !important;}
  .agendaTabs {width: 100%;}
}
@media screen and (min-width: @max-screen){
  .el-tab-pane{font-size: 14px;width: 120px;position: relative;}
  .sp1{position: absolute;top: 18%;font-size: 20px;font-weight: bold;}
  .sp2{position: absolute;top: 75%;font-size: 20px;font-weight: bold;}
  .morning{margin-left: 150px;border-left: 2px dashed #9ecaed;position: relative;display: flex;flex-direction: column;justify-content: center;}
  .ftime{font-size: 15px;font-weight: bold;background: #F5FAFE;margin-top: -29px;margin-left: -25px;}
  .etime{font-size: 15px;font-weight: bold;background: #F5FAFE;margin-left: -25px;}
  li {display: flex;width: 1200px;font-size: 18px;border-width:1px;align-items: center;}
  .meetingtime{margin-top: 0px;background: #B7DBFA;width: 24%;font-weight: bold;}
  .address{margin-top: 0px;background: #B7DBFA;width: 30%;font-weight: bold;margin-left: -56px;}
  .meeting{margin-top: 0px;background: #B7DBFA;width: 46%;font-weight: bold;margin-left: -40px;}
  ul li{background-color:#e4f4fa;margin-left: 40px;font-size: 14px;}
  .time{width: 250px;margin-left: 60px;font-size: 16px;text-align: center;}
  .afternoon{margin-left: 150px;border-left: 2px dashed #9ecaed;position: relative;display: flex;flex-direction: column;justify-content: center;
  .ftime{font-size: 15px;font-weight: bold;background: #F5FAFE;margin-top: -31px;margin-left: -25px;}
  .etime{font-size: 15px;font-weight: bold;margin-left: -25px;}}
  .night{margin-left: 150px;border-left: 2px dashed #9ecaed;position: relative;height:90px;
  .ftime{position: absolute;top: 15px;left:40px;font-size: 15px;font-weight: bold;background: #F5FAFE;}
  .etime{position: absolute;top: 64px;left:40px;font-size: 15px;font-weight: bold;}}
  ul li:nth-child(2n+1){background-color:#e9f9f9;}
  .night::before {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; position: absolute;top: -27px;left: -10px;color: #1265F6;}
  .night::after {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; position: absolute;top: 52px;left: -10px;color: #1265F6;}
  .afternoon::before {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top;color: #1265F6;margin-left: -78px;}
  .afternoon::after {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top;color: #1265F6;margin-left: -78px;margin-top: -31px;}
  .morning::before {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; color: #1265F6;margin-left: -78px;}
  .morning::after {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; color: #1265F6;margin-left: -78px;margin-top: -29px;}
  .noon{margin-left: 150px;border-left: 2px dashed #9ecaed;position: relative;
    .ftime{position: absolute;top: -16px;margin-left: -25px;font-size: 15px;font-weight: bold;background: #F5FAFE;}
    .etime{position: absolute;top: 64px;margin-left: -25px;font-size: 15px;font-weight: bold;background: #F5FAFE;}
  }
  .noon::before {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; position: absolute;top: -27px;left: -10px;color: #1265F6;}
  .noon::after {content: "●";font-size: 30px;margin-right: 4px;vertical-align: top; position: absolute;top: 52px;left: -10px;color: #1265F6;}
  .arrangement{width: 520px;cursor: pointer;text-align: center;margin-left: 25px;}
  /deep/.el-tabs__item {font-size: 18px !important;}
  .agendaTabs {width: 1100px;}
}

.agendaTabs {position: relative;font-size: 16px;margin: auto;background: #F5FAFE;}
/deep/.el-tabs__header{background: #ECF6FF;}
/deep/.el-step__icon.is-text{border: 0px}
/deep/.el-step.is-vertical .el-step__line{width: 0;}
/deep/.el-step__line{border: 1px #24C0C5 dashed;background-color: #ffffff;}
/deep/.el-step__title.is-wait{color: #000;width: 200px;font-size: 17px;}
/deep/.el-step__description.is-wait{color: #000;width: 400px;height: 55px;margin: -5px 0 20px 200px;font-size: 18px;}
.font{font-weight: bold;}
i {width: 1200px; height: 30px;display: inline-block;background: #DEEFF8;margin: auto;margin-top: 30px;}
</style>

<!--何宽  2021.6.8
    该卡片组件使用场景：鼠标点击tabs标题，面板上的内容切换到对应的标题下的内容。鼠标点击 arrangement，返回相应的对象给父组件 -->
<template>
  <el-tabs class="agendaTabs" v-model="activeName">
    <el-tab-pane v-for="(item, index) in TabsList" :key="index" :label="item.data" :name="item.id">
      <span class="sp1">上午</span>
      <span class="sp2">下午</span>
      <div class="beforeline">
            <li>
              <p class="meetingtime">时间</p>
              <p class="address">地点</p>
              <p class="meeting">会议名称</p>
            </li>
          <ul class="morning">
          <span class="ftime">8:30</span>
          <li v-for="(citem, cindex) in item.content" :key="cindex">
            <p class="time" v-if="citem.type === 0">{{ citem.address }}</p>
            <p class="arrangement" @click="loadNews(citem)" :class="{font:fontstyle}" v-if="citem.type === 0" v-html="decodeHtml(citem.arrangement)"></p>
          </li>
          <span class="etime">12:00</span>
        </ul>
        <div v-for="(citem, cindex) in item.content" :key="cindex">
          <ul class="noon" v-if="citem.type === 2">
          <span class="ftime">12:30</span>
          <span class="etime">13:30</span>
          <li>
            <p class="time" v-if="citem.type === 2">{{ citem.address }}</p>
            <p class="arrangement" @click="loadNews(citem)" :class="{font:fontstyle}" v-if="citem.type === 2" v-html="decodeHtml(citem.arrangement)" ></p>
          </li>
        </ul>
        </div>
        <i></i>
          <ul class="afternoon">
            <span class="ftime">14:30</span>
            <li v-for="(citem, cindex) in item.content" :key="cindex">
              <p class="time" v-if="citem.type === 1">{{ citem.address }}</p>
              <p class="arrangement" @click="loadNews(citem)" :class="{font:fontstyle}" v-if="citem.type === 1" v-html="decodeHtml(citem.arrangement)"></p>
            </li>
            <span class="etime">17:30</span>
          </ul>
          <div v-for="(citem, cindex) in item.content" :key="cindex">
            <ul class="night"  v-if="citem.type === 3" >
            <li style="background:#e4f4fa;">
              <span class="ftime" v-if="citem.type === 3" >18:00</span>
              <span class="etime" v-if="citem.type === 3" >20:00</span>
              <p class="time" v-if="citem.type === 3" >{{ citem.address }}</p>
              <p class="arrangement" @click="loadNews(citem)" :class="{font:fontstyle}" v-if="citem.type === 3" v-html="decodeHtml(citem.arrangement)"></p>
            </li>
          </ul>
          </div>
      </div>
      <!-- <el-steps direction="vertical" >
        <el-step v-for="(citem, cindex) in item.content" :key="cindex" :title="citem.time" :description="citem.arrangement">
          <template slot="icon">
            <img src="../../../../static/images/diansss.png">
          </template>
        </el-step>
      </el-steps> -->
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  props: ['TabsList'],
  data()
  {
    return {
      activeName: '0',
      fontstyle: false,
      isshow: false
    }
  },

  methods: {
    decodeHtml(content)
    {
      return window.public.decodeContent(content)
    },
    // 点击标题跳转详情页
    loadNews(val)
    {
      if (val.glid)
      {
        let url = this.$router.resolve({path: '/DhxwDetails', query: {id: val.glid}})
        window.open(url.href, '_blank')
      }
      else
        this.$message.error('该日程还未绑定会议')
    }
    // 判断日程是否有会议
    // getMeeting()
    // {
    //   for (let i = 0; i < this.TabsList.length; i++)
    //   {
    //     for (let j = 0; j < this.TabsList[i].content.length; j++)
    //     {
    //       if (this.TabsList[i][j].glid)
    //         this.fontstyle = true
    //     }
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/AgendaTabs.vue